import { useJumpLastUrl } from '@!/Hooks'
import { VStack, Text, Box } from '@chakra-ui/react'
import { NormalButton } from '@!/components/Button'
import { ScrollableLatelyAccessList } from '@!/Store/Common/components/ScrollableLatelyAccessList'

export const MonthlyCourseRegistrationComplete = (props) => {
  const jumpLastUrl = useJumpLastUrl()
  const { monthly_course_name, error } = props.params
  let text = `月額${monthly_course_name}の登録が完了しました。`

  if (error) {
    switch (error) {
      case 'FAILED_REGISTER':
        text = '月額コースの登録に失敗しました。再度登録を行ってください。'
        break
      default:
        text = 'エラーが発生しました。しばらく時間をおいて再度お試しください。'
    }
  }

  return (
    <VStack spacing={16} pt={16} pb={6}>
      <Text fontSize="sm">{text}</Text>
      <Box w="100%" px={4}>
        {error ? (
          <NormalButton onClick={() => (window.location.href = '/user/payment')}>登録ページに戻る</NormalButton>
        ) : (
          <NormalButton onClick={jumpLastUrl}>元のページに戻る</NormalButton>
        )}
      </Box>
      <Box w="100%">
        <ScrollableLatelyAccessList />
      </Box>
    </VStack>
  )
}
